/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable new-cap */
import CardWrapper from '../wrapper/card';
import CustomDropdown from '../reusable/dropdown';
import { Delete } from '@mui/icons-material';
import enUS from 'date-fns/locale/en-US';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { AvailabilityHoursObject, SaveCustomHoursParams } from '../../params/redux/calendar';
import { Calendar as BigCalendar, dateFnsLocalizer } from 'react-big-calendar';
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Typography } from '@mui/material';
import { enableDisabledCustomHourThunk, fetchCustomTimeOfDateThunk, removeTimeThunk, updateCustomTimeOfDateThunk } from '../../redux/thunks/calendar';
import { format, getDay, parse, startOfWeek } from 'date-fns';
import { getFilteredEndTimeOptions, getFilteredStartTimeOptions } from '../../helper/time_conflict';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { brand } from '../../theme/themePrimitives';

const locales = { 'en-US': enUS };
const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales
});

const CalendarAvailability = () => {
    const { id } = useParams();
    const dispatch = useDispatch<AppDispatch>();
    const [, setSelectedTimeZone] = useState<string>('');
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedCustomer } = useSelector((state: RootState) => state.customer);
    const { slots } = useSelector((state: RootState) => state.calendar);

    const handleAddTimeBlock = async () => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            const monthName = selectedDate?.toLocaleString('default', { month: 'long' }) as string;
            const data: SaveCustomHoursParams = {
                user_id,
                start_time: '',
                end_time: '',
                date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '',
                month: monthName,
                availability_hours_id: null
            };
            await dispatch(updateCustomTimeOfDateThunk(data)).unwrap();
        } catch (e) {
            //
        }
    };

    const handleDateChange = async (date: Date) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            setSelectedDate(date);
            const monthName = date.toLocaleString('default', { month: 'long' });
            await dispatch(fetchCustomTimeOfDateThunk({
                user_id,
                date: format(date, 'yyyy-MM-dd'),
                month: monthName
            })).unwrap();
        } catch (e) {
            //
        }
    };

    const handleTimeChange = async (index: number, type: 'from' | 'to', value: string, time: AvailabilityHoursObject) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            const monthName = selectedDate?.toLocaleString('default', { month: 'long' }) as string;
            const data: SaveCustomHoursParams = {
                user_id,
                start_time: type === 'from' ? value : time.start_time || '',
                end_time: type === 'to' ? value : time.end_time || '',
                date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '',
                month: monthName,
                availability_hours_id: time.id
            };
            await dispatch(updateCustomTimeOfDateThunk(data)).unwrap();
        } catch (e) {
            //
        }
        // const updated = [...timeBlocks];
        // updated[index][type] = value;
        // setTimeBlocks(updated);
    };

    useEffect(() => {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setSelectedTimeZone(tz);
    }, []);

    const handleRemoveTimeBlock = async (hour_id: number) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            await dispatch(removeTimeThunk({
                hour_id,
                user_id,
                date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '',
                month: selectedDate ? selectedDate?.toLocaleString('default', { month: 'long' }) : ''
            })).unwrap();
        } catch (e) {
            //
        }
    };

    const handleCheckUncheck = async (value: boolean) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            const monthName = selectedDate?.toLocaleString('default', { month: 'long' }) as string;
            await dispatch(enableDisabledCustomHourThunk({
                user_id,
                month: monthName,
                date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '',
                status: value ? 'enabled' : 'disabled'
            })).unwrap();
        } catch (e) {
            //
        }
    };

    return (
        <>
            <Box display="flex" gap={4} mt={2}>
                {/* Left Calendar */}
                <CardWrapper flex={3}>
                    <Typography variant="subtitle1" color="textDisabled" mb={2}>Select the days you are available</Typography>
                    <BigCalendar
                        localizer={localizer}
                        selectable
                        defaultView="month"
                        views={['month']}
                        date={selectedDate || new Date()}
                        onNavigate={(date) => {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            if (date >= today) {
                                handleDateChange(date);
                            }
                        }}
                        onSelectSlot={(slotInfo) => {
                            const clickedDate = new Date(slotInfo.start);
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            if (clickedDate >= today) {
                                handleDateChange(clickedDate);
                            }
                        }}
                        min={new Date()}
                        dayPropGetter={(date) => {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            const isSelected = selectedDate && date.toDateString() === selectedDate.toDateString();
                            const isPast = date.getTime() < today.getTime();
                            return {
                                style: {
                                    backgroundColor: isSelected ? brand[300] : isPast ? '#ebebeb' : 'white',
                                    color: isSelected ? 'white' : isPast ? 'lightgray' : 'black',
                                    pointerEvents: isPast ? 'none' : 'auto',
                                    cursor: 'pointer',
                                    opacity: isPast ? 0.6 : 1
                                }
                            };
                        }}
                        style={{ height: 500 }}
                    />
                </CardWrapper>

                {/* Right Panel */}
                <Box flex={1}>
                    <CardWrapper>
                        {selectedDate
                            ? <>
                                <Typography variant="subtitle1" mb={1}>
                                    Set your available hours for selected day and override your availability for dates that differ from your regular hours
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={slots.customHours.makeMeNotAvailable}
                                            onChange={(e) => handleCheckUncheck(e.target.checked)}
                                        />
                                    }
                                    label="Make me not available this day"
                                />
                                {!slots.customHours.makeMeNotAvailable && (
                                    <>
                                        {slots.customHours.times.map((block: AvailabilityHoursObject, i: number) => (
                                            <Grid container spacing={2} key={i} mt={1}>
                                                <Grid item xs={slots.customHours.times.length > 1 ? 5 : 6}>
                                                    <CustomDropdown
                                                        value={block.start_time}
                                                        onChange={(e) => handleTimeChange(block.id, 'from', e.target.value as string, block)}
                                                        options={getFilteredStartTimeOptions(slots.customHours.times, block.id)}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 500,
                                                                    overflowY: 'auto'
                                                                }
                                                            }
                                                        }}
                                                        sx={{ mb: 0 }}
                                                    />
                                                </Grid>
                                                <Grid item xs={slots.customHours.times.length > 1 ? 5 : 6}>
                                                    <CustomDropdown
                                                        value={block.end_time}
                                                        onChange={(e) => handleTimeChange(block.id, 'to', e.target.value as string, block)}
                                                        options={getFilteredEndTimeOptions(block, slots.customHours.times)}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 500,
                                                                    overflowY: 'auto'
                                                                }
                                                            }
                                                        }}
                                                        sx={{ mb: 0 }}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {slots.customHours.times.length > 1 && (
                                                        <IconButton
                                                            onClick={() => handleRemoveTimeBlock(block.id)}
                                                            size="small"
                                                            aria-label="delete time block"
                                                            color="error"
                                                        >
                                                            <Delete fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        ))}
                                        <Button fullWidth variant="outlined" sx={{ mt: 2 }} onClick={handleAddTimeBlock}>
                                            + Add Time
                                        </Button>
                                    </>
                                )}
                            </>
                            : (
                                <Box
                                    height={200}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{ color: 'text.secondary', textAlign: 'center', px: 2 }}
                                >
                                    <Typography variant="body1">
                                        To add availability, please select a date from the calendar.
                                    </Typography>
                                </Box>
                            )}
                    </CardWrapper>
                </Box>
            </Box></>
    );
};

export default CalendarAvailability;
